<div class="partner-offer-edit-container">
  <!-- Loading state -->
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Ładowanie danych oferty...</p>
    </div>
  }

  <!-- Error state -->
  @if (error && !loading) {
    <div class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
    </div>
  }

  <!-- Offer form -->
  @if (!loading && !error) {
    <form [formGroup]="offerForm" (ngSubmit)="onSubmit()" class="offer-form">
      <h2>{{ offerId ? 'Edytuj' : 'Dodaj' }} Ofertę</h2>
      <!-- Is Active Field -->
      <div class="checkbox-field">
        <mat-checkbox formControlName="is_active">
          Oferta aktywna
        </mat-checkbox>
        <p class="field-hint">Odznacz, aby ukryć ofertę bez usuwania</p>
      </div>
      <!-- Title Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tytuł oferty</mat-label>
        <input matInput
          formControlName="title"
          placeholder="Wprowadź tytuł oferty"
          required>
        @if (offerForm.get('title')?.hasError('required')) {
          <mat-error>
            Tytuł jest wymagany
          </mat-error>
        }
      </mat-form-field>
      <!-- Intro Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Wstęp</mat-label>
        <textarea matInput
          formControlName="intro"
          placeholder="Krótki opis oferty"
          rows="3">
        </textarea>
      </mat-form-field>
      <!-- Content Field -->
      <div class="content-field">
        <label>Treść oferty</label>
        <app-html-editor
          formControlName="content">
        </app-html-editor>
      </div>
      <!-- Discount Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Zniżka</mat-label>
        <input matInput
          formControlName="discount"
          placeholder="np. 20%, 50 zł">
      </mat-form-field>
      <!-- Category Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Kategoria</mat-label>
        <mat-select formControlName="category_id">
          <mat-option [value]="null">Brak kategorii</mat-option>
          @for (category of categories; track category) {
            <mat-option [value]="category.id">
              {{ category.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- File Upload Section -->
      <div class="file-upload-section">
        <h3>Zdjęcie oferty</h3>
        <!-- Current Image Display -->
        @if (offerForm.get('file')?.value) {
          <div class="current-image">
            <img [src]="getOfferImageUrl($safeNavigationMigration(offerForm.get('file')?.value))"
              alt="Aktualne zdjęcie oferty"
              class="offer-image-preview">
            <p>Aktualne zdjęcie: {{ offerForm.get('file')?.value }}</p>
          </div>
        }
        <!-- File Input -->
        <div class="file-input-container">
          <input type="file"
            #fileInput
            accept="image/*"
            (change)="onFileSelected($event)"
            style="display: none;">
          <button type="button"
            mat-stroked-button
            color="primary"
            (click)="fileInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            {{ offerForm.get('file')?.value ? 'Zmień zdjęcie' : 'Wybierz zdjęcie' }}
          </button>
          @if (offerForm.get('file')?.value) {
            <span class="selected-file-name">
              Aktualny plik: {{ offerForm.get('file')?.value }}
            </span>
          }
        </div>
      </div>
      <!-- Valid Until Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Ważne do</mat-label>
        <input matInput
          [matDatepicker]="validPicker"
          formControlName="valid"
          placeholder="dd.mm.yyyy"
          readonly>
        <mat-hint>Format: dd.mm.yyyy</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="validPicker"></mat-datepicker-toggle>
        <mat-datepicker #validPicker></mat-datepicker>
      </mat-form-field>
      <!-- Form Actions -->
      <div class="form-actions">
        <button type="submit"
          mat-raised-button
          color="primary"
          [disabled]="offerForm.invalid || saving">
          @if (saving) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!saving) {
            <span>{{ offerId ? 'Zapisz zmiany' : 'Utwórz ofertę' }}</span>
          }
          @if (saving) {
            <span>Zapisywanie...</span>
          }
        </button>
        <button type="button"
          mat-button
          color="warn"
          [disabled]="saving"
          (click)="offerForm.reset()">
          Wyczyść formularz
        </button>
      </div>
    </form>
  }
</div>
